import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  key: 0,
  class: "dashboard-card pt-2 px-3"
}
const _hoisted_3 = { class: "team-info-drawer__header fixed-header" }
const _hoisted_4 = {
  class: "title ellipsis mr-2",
  style: {"max-width":"55vw"}
}
const _hoisted_5 = { class: "row align-end px-4 fixed-header mt-h" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"110px"} }, null, -1)

import TeamLimitsTable from '@/components/TeamLimitsTable.vue';
import TeamReportTable from '@/components/TeamReportTable.vue';
import { useAccountStore } from '@/stores/account';
import { useProgramsStore } from '@/stores/programs';
import { computed, ref, watch } from 'vue';
import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'TeamReports',
  setup(__props) {

const programsStore = useProgramsStore()
const router = useRouter()

const program = computed(() => programsStore.programs.find(item => item.id === router.currentRoute.value.params.programId))
const currentTeamId = ref<string | null>(null)

const accountStore = useAccountStore()
const teams = computed(() => {
  if (!accountStore.isDirector) {
    return program.value?.teams.filter(team => team.trackerId === accountStore.currentUser?.id)
  }
  return program.value?.teams
})

const currentTeam = computed(() => {
  return program.value?.teams.find(team => team.id === currentTeamId.value)
})

watch(() => program.value, () => {
  if (!program.value) return
  const team = teams.value && teams.value[0]
  if (!team) return
  currentTeamId.value = team?.id
}, { immediate: true })

watch(() => currentTeam.value, () => {
  if (!currentTeam.value) return
  programsStore.requestReports(currentTeam.value)
}, { immediate: true })

const tabs = ref("reports")


return (_ctx: any,_cache: any) => {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(currentTeam))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(currentTeam)?.name) + ": Сравнение отчетов трекера", 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_v_tabs, {
              modelValue: tabs.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tabs).value = $event)),
              color: "primary",
              style: {"flex":"0 0 auto"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_tab, { value: "reports" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Отчеты")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_tab, { value: "limits" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Ограничения")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_v_select, {
              modelValue: currentTeamId.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currentTeamId).value = $event)),
              items: _unref(teams),
              class: "v-select-min",
              variant: "outlined",
              label: "Команда",
              "item-value": "id",
              "item-title": "name"
            }, null, 8, ["modelValue", "items"])
          ]),
          _hoisted_6,
          (_unref(currentTeam).reports)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (tabs.value === 'reports')
                  ? (_openBlock(), _createBlock(TeamReportTable, {
                      key: 0,
                      team: _unref(currentTeam)
                    }, null, 8, ["team"]))
                  : (_openBlock(), _createBlock(TeamLimitsTable, {
                      key: 1,
                      team: _unref(currentTeam),
                      class: "mx-4"
                    }, null, 8, ["team"]))
              ], 64))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})